import { useParams, useNavigate, useLocation } from "react-router-dom";
import { use, useEffect, useState } from "react";
import * as Yup from "yup";

// Step components
import ServiceSection from "../PageElements/HomePageElements/ServiceSection.jsx";
import StepTracker from "../PageElements/BookingAppointmentElements/SetpTrackerSection";
import DoctorInfoCard from "../PageElements/BookingAppointmentElements/DoctorCardInfo";
import DateAndTimeSection from "../PageElements/BookingAppointmentElements/DateAndTimeSection";
import BasicInfoSection from "../PageElements/BookingAppointmentElements/BasicInfoSection.jsx";
// import PaymentSection from "../PageElements/BookingAppointmentElements/PaymentSection.jsx";
import ConfirmationSection from "../PageElements/BookingAppointmentElements/ConfirmationSection.jsx";
import {
  bookAppointment,
  getDoctorDetails,
  getOtp,
  getProfileStatus,
  registeredPatient,
  validateOtp,
} from "../api/api.js";
import { convertToMMDDYYYY, formatDate, formatDobDisplay } from "../utils/helper.js";
import toast from "react-hot-toast";
import OpdOtpVerification from "../PageElements/DoctorsGridPageElements/OpdOtpVerification.jsx";
import OtpValidate from "../PageElements/HomeCollectionPageElements/OtpValidate.jsx";
import BookingSucessModal from "../PageElements/BookingAppointmentElements/BookingSucessModal.jsx";
import { getUserData, getUserMobile } from "../utils/auth.js";

// Step order and mapping
const stepOrder = ["date-and-time", "patient-details", "confirm"];
const stepComponents = {
  "date-and-time": DateAndTimeSection,
  "patient-details": BasicInfoSection,
  // payment: PaymentSection,
  confirm: ConfirmationSection,
};

export default function BookAppointmentPage() {
  const { step } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  // const doctor = location.state?.doctor;
  const isLoggedin = Boolean(getUserData());

  const [doctorDetails, setDoctorDetails] = useState({});
  const doctorFromState = location.state?.doctor;
  const [doctorData, setDoctorData] = useState([]);
  const [selectedTime, setSelectedTime] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [formData, setFormData] = useState({
    user_id: "",
    Mobile_no: "",
    Alt_mobile_no: "",
    Dateofbirth: "",
    Email: "",
    FName: "",
    LName: "",
    Gender: "",
  });
  const [mobileValue, setMobileValue] = useState("");
  const [profileData, setProfileData] = useState([]);
  const [showVerification, setShowVerification] = useState(!isLoggedin);
  const [selectedPatient, setSelectedPatient] = useState("");
  const [opdTiming, setOpdTiming] = useState("");
  const [errors, setErrors] = useState({});
  const [showOtp, setShowOtp] = useState(false);
  const [patientType, setPatientType] = useState("");
  const [showPatientType, setShowPatientType] = useState(isLoggedin);
  const [isBooked, setIsBooked] = useState(false);
  const [appointmentData, setAppointmentData] = useState('');
  const [isOtpverified, setIsOtpverified] = useState(false);

  const basicInfoSchema = Yup.object().shape({
    Mobile_no: Yup.string()
      .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits")
      .required("Mobile number is required"),

    Alt_mobile_no: Yup.string()
    .nullable()
    .test(
      "alt-mobile-valid",
      "Alternate mobile number must be 10 digits",
      (value) => {
        if (!value) return true;
        return /^[0-9]{10}$/.test(value);
      }
    ),

    FName: Yup.string()
      .matches(/^[A-Za-z ]+$/, "First name can only contain letters")
      .required("First name is required"),

    LName: Yup.string()
      .matches(/^[A-Za-z ]+$/, "Last name can only contain letters")
      .required("Last name is required"),

    Email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),

    Dateofbirth: Yup.date()
      .max(new Date(), "DOB cannot be in the future")
      .required("Date of birth is required"),
    Gender: Yup.string()
      .required("Gender is required")
      .oneOf(["M", "F"], "Invalid gender"),
  });

  useEffect(() => {
    if (mobileValue.length === 10) {
      // const timer = setTimeout(() => {
      //   handleCheckProfile(mobileValue);
      // }, 400);
      // return () => clearTimeout(timer);
      handleCheckProfile(mobileValue);
    }
  }, [mobileValue]);

  // If user is logged in, prefill mobile and trigger profile check on mount
  useEffect(() => {
    if (isLoggedin) {
      const storedMobile = getUserMobile();
      if (storedMobile && storedMobile.toString().replace(/\D/g, "").length === 10) {
        setMobileValue(storedMobile);
        setFormData((prev) => ({ ...prev, Mobile_no: storedMobile }));
        // trigger profile check for logged in mobile
        handleCheckProfile(storedMobile);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedin]);

  const handleCheckProfile = async (mobileValue) => {
    const payload = {
      RBAuthKey: "RBDWAh!Q1s74e",
      user_id: "",
      mobile_no: mobileValue,
    };
    try {
      setLoading(true);
      const res = await getProfileStatus(payload);
      console.log("Profile Status Response:", res);
      setProfileData(res?.data?.data);
      setShowVerification(true);
    } catch (error) {
      console.error("Error checking profile:", error);
    }
  };

  //   const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   if (name === "Mobile_no") {
  //     setMobileValue(value);
  //   }

  //   setFormData((prevData) => {

  //     if (name === "Dateofbirth") {
  //       return {
  //         ...prevData,
  //         [name]: formatDate(value),
  //       };
  //     }

  //     return {
  //       ...prevData,
  //       [name]: value,
  //     };
  //   });
  // };

  const handleChange = async (e) => {
  const { name, value } = e.target;

  let processedValue = value;

  // ✅ Mobile & Alternate Mobile: numbers only, max 10
  if (name === "Mobile_no" || name === "Alt_mobile_no") {
    processedValue = value.replace(/\D/g, "").slice(0, 10);

    if (name === "Mobile_no") {
      setMobileValue(processedValue);
    }
  }

  // ✅ First & Last name: letters and spaces only
  if (name === "FName" || name === "LName") {
    processedValue = value.replace(/[^A-Za-z ]/g, "");
  }

  
  // if (name === "Dateofbirth") {
  //   processedValue = formatDate(value);
  // }

  // ✅ Update form data
  setFormData((prevData) => ({
    ...prevData,
    [name]: processedValue,
  }));

  try {
    // ✅ Validate only this field
    await basicInfoSchema.validateAt(name, {
      ...formData,
      [name]: processedValue,
    });

    setErrors((prev) => ({ ...prev, [name]: "" }));
  } catch (err) {
    setErrors((prev) => ({ ...prev, [name]: err.message }));
  }
};


  const handleTimeClick = (time) => {
    setSelectedTime(time);
    console.log("Selected time >>", time);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };
  // console.log("doctor details id >>", doctorDetails.doctor_id)

  useEffect(() => {
    if (doctorFromState) {
      setDoctorDetails(doctorFromState);
      localStorage.setItem("selectedDoctor", JSON.stringify(doctorFromState));
      // setDoctorDetails(doctorFromState);
    }
  }, [doctorFromState]);

  useEffect(() => {
    if (doctorDetails?.doctor_id) {
      fetchDoctorDetails(doctorDetails.doctor_id);
    }
  }, [doctorDetails]);

  const storedDoctor = localStorage.getItem("selectedDoctor");
  const doctor =
    doctorFromState || (storedDoctor ? JSON.parse(storedDoctor) : null);

  // console.log(doctor)
  const [selectedCenter, setSelectedCenter] = useState(
    doctor?.centers?.[0] || null
  );

  const handleCenterChange = (center) => {
    setSelectedCenter(center);
    console.log("Selected center >>", center);
  };

  useEffect(() => {
    if (!step || !stepOrder.includes(step)) {
      navigate("/appointment/date-and-time", { replace: true });
    }
  }, [step, navigate]);

  const currentStepIndex = stepOrder.indexOf(step);
  const CurrentStepComponent = stepComponents[step];

  const fetchDoctorDetails = async (doctorId) => {
    console.log("fetching dr details >>", doctorId);
    const payload = { doctor_id: doctorId };
    console.log("payload for dr details >>", payload);
    try {
      const response = await getDoctorDetails(payload);
      setDoctorData(response?.data?.data || {});
    } catch (error) {
      console.error("Error fetching doctor details:", error);
    }
  };

  const goToNext = () => {
    if (currentStepIndex < stepOrder.length - 1) {
      navigate(`/appointment/${stepOrder[currentStepIndex + 1]}`, {
        state: { doctor },
      });
    }
  };

  const goToPrev = () => {
    if (currentStepIndex > 0) {
      navigate(`/appointment/${stepOrder[currentStepIndex - 1]}`, {
        state: { doctor },
      });
    }
  };

  const handleOtp = async () => {
    try {
      const payload = {
        RBAuthKey: "RBDWAh!Q1s74e",
        mobile_no: formData?.Mobile_no,
      };
      const res = await getOtp(payload);
      console.log("OTP Response:", res);
      setShowVerification(false);
      setShowOtp(true);
    } catch (error) {
      console.error("Error generating OTP:", error);
      setErrors("Failed to generate OTP. Please try again.");
    }
  };

  const handlePatientChange = (e) => {
  const userId = e.target.value;
  setSelectedPatient(userId);

  const selectedProfile = profileData.find(
    (profile) => profile.user_id === userId
  );

  if (selectedProfile) {
    const altMobile = selectedProfile.Alt_mobile_no;

    setFormData((prev) => ({
      ...prev,
      user_id: selectedProfile.user_id ?? "",
      Mobile_no: selectedProfile.mobile_no ?? "",

      // ✅ blank if less than 10 digits
      Alt_mobile_no:
        altMobile && altMobile.toString().length === 10
          ? altMobile
          : "",

      FName: selectedProfile.PFirstName ?? "",
      LName: selectedProfile.PLastName ?? "",
      Email: selectedProfile.email ?? "",
      Dateofbirth: formatDate(selectedProfile.dateofbirth),
      Gender:
        selectedProfile.PSex === "M"
          ? "M"
          : selectedProfile.PSex === "F"
          ? "F"
          : "M",
    }));

    setErrors({});
  }
};


  const handleSubmitVerify = async (otp) => {
    console.log("Verifying OTP:", otp);

    try {
      if (otp.length < 4) {
        toast.error("Please enter a valid 4-digit OTP.");
        return;
      }

      const payload = {
        RBAuthKey: "RBDWAh!Q1s74e",
        user_id: formData?.Mobile_no,
        OTP: otp,
        Reg_status: "1",
      };

      const res = await validateOtp(payload);
      console.log("OTP Verification Response:", res);
      if (res?.data?.status === "success") {
        toast.success("OTP verified successfully.");
        setIsOtpverified(true);
        setShowOtp(false);
        setErrors(null);
        setShowPatientType(true);
      } else {
        toast.error("OTP verification failed. Please try again.");
      }
    } catch (error) {
      toast.error("OTP verification failed. Please try again.");
    }
  };

  const handleNewRegistration = async () => {
    const current = new Date();
    const pad = (n) => n.toString().padStart(2, "0");
    const date = `${pad(current.getDate())}-${pad(
      current.getMonth() + 1
    )}-${current.getFullYear()}`;
    const payload = {
      RBAuthKey: "RBDWAh!Q1s74e",
      user_id: "",
      FName: formData?.FName,
      LName: formData?.LName,
      Email: formData?.Email,
      Mobile_no: formData?.Mobile_no,
      Alt_mobile_no: formData?.Alt_mobile_no,
      Address: "",
      Landmark: "",
      ZipCode: "",
      City: "",
      State: "",
      Reg_status: "0",
      Pat_status: "0",
      IsMobileregister: "Y",
      Registerdate: date,
      PTitle: formData?.Gender === "M" ? "Mr" : "Mrs",
      Gender: formData?.Gender,
      Dateofbirth: formatDobDisplay(formData?.Dateofbirth),
    };

    try {
      const response = await registeredPatient(payload);
      console.log("Registration response:", response);
      if (response?.data?.status === "success") {
         toast.success("Patient registered successfully.");
      return response?.data?.user_id;
      } else {
        toast.error(
          response?.data?.message ||
            "Failed to register patient. Please try again."
        );
        return;
      }
     
    } catch (error) {
      console.error("Error registering new patient:", error);
    }
  };

  const handleBookAppointment = async (userId) => {
    try {
      setLoading(true);
      //   if (!selectedDate || !selectedTime || !selectedCenter || !doctor) {
      //   toast.error("Please select doctor, date, time and center.");
      //   return;
      // }

      // ✅ booking payload
      const bookingPayload = {
        App_Dt: selectedDate,
        App_Time: selectedTime,
        Appointment_Status: "BOOKED",
        Booking_DT: selectedDate,
        RBAuthKey: "RBDWAh!Q1s74e",
        ...formData,
        PTitle: formData?.Gender === "M" ? "Mr" : "Mrs",
        dateofbirth: formatDobDisplay(formData?.Dateofbirth),
        user_id: userId,
        appointment_id: "",
        center_Name: selectedCenter?.center_name || "",
        center_id: selectedCenter?.center_id || "",
        channel: "W",
        doc_Name: doctor.doc_Name,
        doctor_id: doctor.doctor_id,
        OPDTiming_id: Number(opdTiming),
      };

      const bookingResponse = await bookAppointment(bookingPayload);
      console.log("Booking Response:", bookingResponse);


      if(bookingResponse?.data?.status !== "success") {
        toast.error(
          bookingResponse?.data?.message ||
            "Failed to book appointment. Please try again."
        );
        return;
      }
      
      setAppointmentData(bookingResponse?.data?.Appointment_id || null);
      // toast.success("Appointment booked successfully!");
      setIsBooked(true);
    } catch (error) {
      console.error("Error booking appointment:", error);
    } finally {
      setLoading(false);
    }
  };
const validateFormOnSubmit = async () => {
  try {
    await basicInfoSchema.validate(formData, { abortEarly: false });

    // clear previous errors
    setErrors({});
    return true;
  } catch (validationError) {
    const formErrors = {};

    validationError.inner.forEach((err) => {
      if (!formErrors[err.path]) {
        formErrors[err.path] = err.message;
      }
    });

    setErrors(formErrors);
    return false;
  }
};

  const handleBookedSubmit = async (e) => {
    e.preventDefault();
    const isValid = await validateFormOnSubmit();
  if (!isValid) {
    toast.error("Please fix the errors in the form before submitting.");
    return;
  }

    if (patientType === "new") {
      const newUserId = await handleNewRegistration();
      if (!newUserId) return;
      await handleBookAppointment(newUserId);
    } else if (patientType === "existing") {
      await handleBookAppointment(formData?.user_id);
    }
  };

  if (!CurrentStepComponent) return null;

  return (
    <>
      <StepTracker currentStep={currentStepIndex} />

      <DoctorInfoCard
        doctor={doctor}
        onCenterChange={handleCenterChange}
        selectedCenter={selectedCenter}
        selectedTime={selectedTime}
      />

      
      <CurrentStepComponent
        onNext={goToNext}
        onBack={goToPrev}
        doctorData={doctorData}
        selectedTime={selectedTime}
        handleTimeClick={handleTimeClick}
        formData={formData}
        handleChange={handleChange}
        profileData={profileData}
        handlePatientChange={handlePatientChange}
        selectedPatient={selectedPatient}
        onDateChange={handleDateChange}
        handleBookAppointment={handleBookedSubmit}
        selectedCenter={selectedCenter}
        setOpdTiming={setOpdTiming}
        showPatientType={showPatientType}
        setFormData={setFormData}
        setSelectedPatient={setSelectedPatient}
        isOtpverified={isOtpverified}
        errors={errors}
        setErrors={setErrors}
        patientType={patientType}
        setPatientType={setPatientType}
      />
      {/* <ServiceSection /> */}

      {!isLoggedin && showVerification && profileData?.length > 0 && (
        <OpdOtpVerification
          onClose={() => {setShowVerification(false)
            setFormData((prev) => ({
                ...prev,
                Mobile_no: "",
              }));
          }}
          onOtp={handleOtp}
        />
      )}

      {showOtp && ( 
        <OtpValidate
          onClose={() => { setShowOtp(false)
               setFormData((prev) => ({
                ...prev,
                Mobile_no: "",
              }));
            }}
          onVerify={handleSubmitVerify}
          // onResend={handleResend}
        />
      )}

      {isBooked && (
        <BookingSucessModal
          onClose={() => setIsBooked(false)}
          appointmentData={appointmentData}
          extraProps = {{formData, selectedDate, selectedTime, selectedCenter, doctor}}
        />
      )}
    </>
  );
}
